import { Box, Chip, Accordion as MuiAccordion, Paper, styled } from '@mui/material';

export const Accordion = styled(MuiAccordion)({
  marginBottom: 8,
  borderRadius: 4,
  border: 'none',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  '&:before': { display: 'none' },
  overflow: 'hidden',
});

export const ChecklistHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const ChecklistInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledPaper = styled(Paper)({
  display: 'flex',
  alignItems: 'center',
  width: 400,
  padding: '2px 4px',
  marginBottom: '16px',
});

export const PoiContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

interface StyledChipProps {
  backgroundColor: string;
  textColor: string;
}

export const StyledChip = styled(Chip, {

  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'textColor',
})<StyledChipProps>(({ backgroundColor, textColor }) => ({
  position: 'absolute',
  top: -8,
  right: -8,
  fontSize: '0.7rem',
  height: 20,
  backgroundColor,
  '& .MuiChip-label': {
    paddingLeft: 8,
    paddingRight: 8,
    color: textColor,
  },
}));
